import React, { useState } from "react";
import Text from "../text";
import Image from "../image";
import WizardButton from '../wizard-button';
import ReadMoreButton from '../read-more-button';
import PropTypes from "prop-types";
import styles from "./wizard-card.module.scss";
import Link from "@/components/link";

const WizardCardMobile = ({ title, text, diagnosisType, visitType, wizardButtonText,
                            readMoreUrl, readMoreText, symbolUrl, symbolAlt, mascotUrl, mascotAlt }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className={styles.mobileContainer}>
            <div className={styles.container}>
                <div className={styles.mobileUpperFirstColumn}>
                    <div className={styles.symbolContainer}>
                        <Link
                            icon={symbolUrl}
                            className={styles.mobileSymbol}
                            text={symbolAlt}
                            iconHeight={50}
                            href={readMoreUrl}
                            variant="image"
                        />
                    </div>

                </div>
                <div className={styles.mobileUpperSecondColumn}>
                    <div className={styles.accordionToggle} aria-expanded={open}>
                        <Image src='/icons/circle-arrow-down.svg' width={50} height={50}  className={styles.downArrow} alt='Pil neråt' onClick={() => setOpen(!open)}/>
                    </div>
                </div>
            </div>
            <div className={styles.accordionContainer} aria-expanded={!open}>
                <div className={styles.accordionContent}>
                    <Text tag="h2" variant="h2">{title}</Text>
                    <ReadMoreButton textColor={"black"} url={readMoreUrl} text={readMoreText} className={styles.readMore} />
                    <Text>{text}</Text>
                    <Image className={styles.mobileMascot} src={mascotUrl} alt={mascotAlt} />
                </div>
                {diagnosisType &&
                <div className={styles.wizardButtonContainer}>
                    <WizardButton
                        visitType={visitType}
                        diagnosisType={diagnosisType}
                        text={wizardButtonText}
                        className={styles.wizardButton} />
                </div>
                }
            </div>
        </div>
  );
};

WizardCardMobile.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    diagnosisType: PropTypes.string.isRequired,
    visitType: PropTypes.string.isRequired,
    wizardButtonText: PropTypes.string.isRequired,
    readMoreUrl: PropTypes.string.isRequired,
    readMoreText: PropTypes.string.isRequired,
    symbolUrl: PropTypes.string.isRequired,
    symbolAlt: PropTypes.string.isRequired,
    mascotUrl: PropTypes.string.isRequired,
    mascotAlt: PropTypes.string.isRequired,
};

export default WizardCardMobile;
